import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import SelectWrapper from '~/components/forms/SelectWrapper';
import { cn } from '~/helpers/utils';

export type SelectFieldOption<T = any> = {
  value: T;
  label: string;
  selected?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
};

export type SelectFieldProps<T = any> = {
  name: string;
  label: string;
  options: SelectFieldOption<T>[];
};

const SelectField: React.FC<SelectFieldProps> = ({ name, label, options }) => {
  const { control } = useFormContext();

  const inputId = `field-${name}`;
  const defaultValue = options.find((opt) => opt.selected)?.value ?? '';

  return (
    <div className="form-control">
      <label htmlFor={inputId} className="form-label">
        {label}
      </label>

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <>
            <SelectWrapper>
              <select
                {...field}
                id={inputId}
                className={cn(
                  'form-input appearance-none !py-4 !pr-10',
                  fieldState.error && 'form-input--error'
                )}
              >
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </SelectWrapper>

            {fieldState.error && (
              <span className="text-red-600 text-sm">
                {fieldState.error.message}
              </span>
            )}
          </>
        )}
      />
    </div>
  );
};

export default SelectField;
